import { TransportOrderIdView } from '../../../../models';

export class ShipmentTransportOrderNotificationsLoad {
  public static readonly type = '[ShipmentTransportOrderNotifications] Load Notifications';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderNotificationsSetInitialState {
  public static readonly type = '[ShipmentTransportOrderNotifications] Set Initial State';
}
